import {styled} from '@mui/material/styles'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import Accordion from '@mui/material/Accordion'
import AccordionSummary, {accordionSummaryClasses} from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import {Box, MenuItem, Paper, Popper, Tooltip, tooltipClasses} from '@mui/material'

const StyledPaper = styled(Paper, {shouldForwardProp: (prop) => prop !== 'domainPopper'})(({theme, domainPopper}) => ({
  boxShadow: `2px 4px 8px ${theme.palette.hpGrayDark}`,
  paddingTop: theme.spacing(1),
  paddingBottom: domainPopper ? theme.spacing(0) : theme.spacing(1),
  maxWidth: domainPopper ? '340px' : '100%'
}))

const StyledArrowRightIcon = styled(ArrowRightIcon)(({theme}) => ({
  fontSize: theme.typography.h5.fontSize,
  color: theme.palette.hpGrayDark
}))

const StyledAccordion = styled((props) => <Accordion disableGutters elevation={0} square {...props} />)(() => ({
  border: 'none',
  '&:before': {
    opacity: 0
  }
}))

const StyledAccordionSummary = styled((props) => <AccordionSummary expandIcon={<StyledArrowRightIcon />} {...props} />)(
  ({theme}) => ({
    border: 'none',
    padding: `0px ${theme.spacing(1)}`,
    minHeight: '0px',
    maxHeight: '38px',
    [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
      transform: 'rotate(90deg)'
    },
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
      transform: 'rotate(270deg)'
    },
    [`& .${accordionSummaryClasses.content}`]: {
      marginLeft: theme.spacing(1)
    }
  })
)

const StyledAccordionDetails = styled(AccordionDetails)(({theme}) => ({
  padding: `0px ${theme.spacing(2)}`
}))

const StyledToolTip = styled(({className, ...props}) => <Tooltip {...props} classes={{popper: className}} />)(
  ({theme}) => ({
    [`&.${tooltipClasses.popper}`]: {
      zIndex: 1600
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.hpBaseDarker
    }
  })
)

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
}))

const StyledBullet = styled(Box)(({theme}) => ({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  position: 'absolute',
  left: '5px'
}))

const StyledInfoBox = styled(Box)(({theme}) => ({
  padding: '8px 16px',
  marginTop: '8px',
  marginBottom: '-8px',
  backgroundColor: theme.palette.hpBaseLighter,
  color: theme.palette.hpBaseDark,
  fontSize: theme.typography.subtitle2.fontSize
}))

const StyledLink = styled('a')(({theme}) => ({
  color: theme.palette.hpBaseDark,
  cursor: 'pointer',
  textDecoration: 'underline'
}))

const StyledMenuItem = styled(MenuItem, {shouldForwardProp: (prop) => prop !== 'highlight'})(({highlight, theme}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: highlight ? theme.palette.hpBaseLighter : 'inherit'
}))

const StyledPopper = styled(Popper)(() => ({
  zIndex: 1000
}))

export {
  StyledArrowRightIcon,
  StyledAccordion,
  StyledAccordionSummary,
  StyledAccordionDetails,
  StyledToolTip,
  StyledBox,
  StyledBullet,
  StyledInfoBox,
  StyledLink,
  StyledMenuItem,
  StyledPaper,
  StyledPopper
}
